if (!customElements.get('review-slider')) {
  class ReviewSlider extends HTMLElement {
    constructor() {
      super();

      this.config = JSON.parse(this.querySelector('.config').textContent);
      this.width = this.clientWidth;
      
      if(this.width > 749) {
        this.initSlider();
      }
    }

    initSlider() {
      this.slider = new Swiper(this, this.config);
    }
  }

  customElements.define('review-slider', ReviewSlider);
}
